import React, { useState } from "react";

// Images
import img1 from "../Accests/images/dj/IMG-20250630-WA0013.jpg";
import img2 from "../Accests/images/dj/IMG-20250630-WA0026.jpg";
import img3 from "../Accests/images/dj/IMG-20250702-WA0006.jpg";
import img4 from "../Accests/images/dj/IMG-20250630-WA0013.jpg";

// Video
import video1 from "../Accests/images/dj/VID-20250630-WA0002.mp4";

const DJMusic = () => {
    const [previewSrc, setPreviewSrc] = useState(null);
    const [isVideo, setIsVideo] = useState(false);

    const openPreview = (src, type) => {
        setPreviewSrc(src);
        setIsVideo(type === "video");
    };

    const closePreview = () => {
        setPreviewSrc(null);
        setIsVideo(false);
    };

    return (
        <>
            <div className="pt-24 px-6 bg-gray-100 min-h-screen">
                <h1 className="text-4xl font-bold text-center mb-8 text-pink-600">DJ Music</h1>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {[img1, img2, img3, img4].map((img, i) => (
                        <img
                            key={i}
                            src={img}
                            alt={`DJ Music ${i + 1}`}
                            onClick={() => openPreview(img, "image")}
                            className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                        />
                    ))}

                    <video
                        src={video1}
                        onClick={() => openPreview(video1, "video")}
                        className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                        muted
                        autoPlay
                        loop
                    />
                </div>

                <p className="text-gray-700 mt-6 text-lg leading-relaxed text-center">
                    Get ready to dance all night with high-energy DJ beats, colorful lights, and non-stop party vibes!
                </p>
            </div>

            {/* Preview Modal */}
            {previewSrc && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
                    <div className="absolute inset-0" onClick={closePreview}></div>

                    <div className="relative z-10 max-w-4xl w-full p-4">
                        <button
                            onClick={closePreview}
                            className="absolute top-4 right-4 z-20 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-red-600 hover:text-white transition"
                        >
                            &times;
                        </button>
                        {isVideo ? (
                            <video src={previewSrc} className="w-full rounded-lg" controls autoPlay />
                        ) : (
                            <img src={previewSrc} alt="Preview" className="w-full rounded-lg" />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default DJMusic;
